import { AppBar, Box, Button } from "@mui/material";

import MainLogo from "../../assets/logos/main_logo.png";
import { logoContainer, navbarButton, navbarContainer } from "./styles";
import { NavBarMenu } from "../Menu/NavBarMenu";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../../services/firebase";
import { showToast } from "../../services/toast";

const NavBar = () => {
  const [isLogin, setIsLogin] = useState<boolean>(false);

  const navigate = useNavigate();

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        const uid = user.uid;
        setIsLogin(true);
      } else {
        console.log("user is logged out");
      }
    });
  }, []);

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        navigate("/login");
        setIsLogin(false);
      })
      .catch((error) => {
        console.log("error");
      });
  };

  const onClickMenuButton = (item: string) => {
    if (isLogin) {
      navigate(item);
    } else {
      navigate("/login");
      showToast("You have to login", "error");
    }
  };

  return (
    <AppBar component="header" position="fixed" color="inherit" elevation={0}>
      <Box sx={(theme) => navbarContainer(theme)}>
        <Box sx={(theme) => logoContainer(theme)} onClick={() => navigate("/")}>
          <img
            src={MainLogo}
            height={50}
            width={160}
            alt="logo"
            onClick={() => navigate("/")}
          />
        </Box>
        <Box sx={{ display: { xs: "none", sm: "flex" } }}>
          <Button
            sx={(theme) => navbarButton(theme)}
            onClick={() => navigate("/")}
          >
            Home
          </Button>
          <Button
            sx={(theme) => navbarButton(theme)}
            onClick={() => onClickMenuButton("myChecks")}
          >
            My Checks
          </Button>
          <Button
            sx={(theme) => navbarButton(theme)}
            onClick={() => {
              if (isLogin) {
                handleLogout();
              } else {
                navigate("/login");
              }
            }}
          >
            {isLogin ? "LogOut" : "Login"}
          </Button>
        </Box>
        <NavBarMenu isLogin={isLogin} setIsLogin={setIsLogin} />
      </Box>
    </AppBar>
  );
};

export default NavBar;
